import Translation from './translation'

export default class Francais extends Translation {
    public infos = {
        code: 'fr',
        name: 'Français'
    }
    public data = {
        layout: {
            languagePicker: {
                chooseLanguage: 'Choix de la langue'
            },
            navbar: {
                title: 'Biobank',
                hello: 'Bonjour',
                darkTheme: 'Thème sombre',
                lightTheme: 'Thème clair',
                profile: 'Profil',
                logout: 'Se déconnecter'
            },
            footer: {
                copyright: '© iD3i - 2021'
            },
            menu: {
                home: 'Accueil',
                profile: 'Profil',
                users: 'Utilisateurs',
                facturations: 'Facturations',
                suiviConso: 'Suivi Consommation',
                suiviCA: 'Suivi CA',
                formulaires: 'Formulaires',
                contact: 'Contact',
                etatStock: 'Etat des stocks',
                pmnAdministration: 'PMN Modèles',
                PMN: 'PMN',
                GED: 'Bibliothèque',
                Evenements: 'Evenements',
                formulairesReponseAdministration: 'Demandes clients',
                inventaires: 'Inventaires',
                commandes: 'Commandes',
                ficheImplantation: "Fiche d'implantation",
                ficheImplantationAdmin: "Fiches d'implantations",
                importRotationProduits: 'Rotation des dépôts',
                suiviRecueil: 'Suivi du recueil',
                kits : "Suivi kits",
                actualites : "Actualités"
            }
        },
        auth: {
            login: {
                title: 'Connexion',
                helper: 'Assurez vous que votre mail soit valide',
                email: 'E-mail',
                password: 'Mot de passe',
                forgottenPassword: 'Mot de passe oublié',
                applicationName: 'iD3i',
                register: "S'enregistrer",
                noAccount: 'Pas encore de compte',
                submit: 'Connexion'
            },
            register: {
                title: "S'enregister",
                helper: "Entrez vos informations pour avoir accès à l'intégralité du contenu",
                login: 'Se connecter',
                alreadyRegistered: "J'ai déja un compte",
                firstname: 'Prénom',
                lastname: 'Nom',
                email: 'E-mail',
                password: 'Mot de pass',
                confirmPassword: 'Confirmation du mot de passe',
                phoneNumber: 'Téléphone',
                passwordNoMatch: 'Les mots de passe ne correspondent pas',
                submit: "S'enregister"
            }
        },
        profile: {
            infos: 'Informations générales',
            welcome: 'Bienvenue',
            edit: 'Modifier le profil ?',
            email: 'E-mail',
            lastname: 'Nom',
            firstname: 'Prénom',
            phoneNumber: 'Téléphone',
            validate: 'Valider les modifications'
        },
        plugins: {
            validation: {
                required: 'Ce champs est obligatoire',
                min: 'Ce champs doit contentir un nombre minimum de caractère de : ',
                max: 'Ce champs doit contentir un nombre maximum de caractère de : ',
                email: 'Email invalide'
            },
            swall: {
                alert: {
                    error: 'Erreur',
                    success: 'Succès',
                    warning: 'Attention'
                },
                confirm: {
                    titreSuppression: 'Êtes-vous sûr ?',
                    texteSuppression: 'La suppression est définitive !',
                    confirmSuppression: "Oui, supprimer l'élément",
                    cancelSuppression: 'Non, annuler',
                    cancel: 'Annuler'
                },
                toast: {
                    success: 'Opération réussie !',
                    error: "Échec de l'opération"
                },
                ok: 'OK',
                erreurServeur: 'Erreur du serveur',
                codeErreur: 'Erreur',
                erreurConnexion: 'Échec de la connexion'
            }
        }
    }
}
